"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var antd_1 = require("antd");
var LocaleWrapper_1 = require("../../../LocaleWrapper/LocaleWrapper");
var en_US_1 = __importDefault(require("../../../../locale/en_US"));
var SourceChannelNameField_1 = __importDefault(require("../SourceChannelNameField/SourceChannelNameField"));
var _get = require('lodash/get');
var _cloneDeep = require('lodash/cloneDeep');
/**
 * GrayChannelField to map a band to grayscale
 */
var GrayChannelField = /** @class */ (function (_super) {
    __extends(GrayChannelField, _super);
    function GrayChannelField() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onGrayChannelChange = function (value) {
            var _a = _this.props, channelSelection = _a.channelSelection, onChange = _a.onChange;
            var gray = value;
            var newChannelSelection;
            if (channelSelection && channelSelection.hasOwnProperty('grayChannel')) {
                newChannelSelection = _cloneDeep(channelSelection);
                newChannelSelection.grayChannel.sourceChannelName = gray;
            }
            else {
                newChannelSelection = {
                    grayChannel: {
                        sourceChannelName: gray
                    }
                };
            }
            if (onChange) {
                onChange(newChannelSelection);
            }
        };
        return _this;
    }
    GrayChannelField.prototype.render = function () {
        var _a = this.props, sourceChannelNames = _a.sourceChannelNames, channelSelection = _a.channelSelection, locale = _a.locale;
        var formItemLayout = {
            labelCol: { span: 8 },
            wrapperCol: { span: 16 }
        };
        return (React.createElement("div", null,
            React.createElement(antd_1.Form.Item, __assign({ label: locale.grayLabel }, formItemLayout),
                React.createElement(SourceChannelNameField_1.default, { sourceChannelNames: sourceChannelNames, onChange: this.onGrayChannelChange, sourceChannelName: _get(channelSelection, 'grayChannel.sourceChannelName') }))));
    };
    GrayChannelField.componentName = 'GrayChannelField';
    GrayChannelField.defaultProps = {
        locale: en_US_1.default.GsGrayChannelField
    };
    return GrayChannelField;
}(React.Component));
exports.GrayChannelField = GrayChannelField;
exports.default = LocaleWrapper_1.localize(GrayChannelField, GrayChannelField.componentName);
//# sourceMappingURL=GrayChannelField.js.map